import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { categoriasDeGraficos } from '../../common/utils';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class GraficosPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            graficos: [],
            graficoSelecionado: [{titulo_grafico: '', categoria: ''}],
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarGraficos();
    }

    carregarGraficos = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/graficos/?programa_id=${this.state.programa_id}&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    graficos: {
                        ...response.data,
                        results:response.data.results.map(grafico => ({
                            id: grafico.id,
                            titulo_grafico: grafico.titulo_grafico,
                            categoria: grafico.categoria,
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar graficos:', error);
                
                let erro_msg = 'Erro ao carregar graficos do programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleGraficosChange = (e, fieldName) => {
        const { name, value } = e.target;
        this.setState({ graficoSelecionado: { ...this.state.graficoSelecionado, [name]: value } });
    }

    handleSalvarGrafico = async () => {
        const formData = new FormData();
        const url = this.state.graficoSelecionado.id ? `/programas/graficos/${this.state.graficoSelecionado.id}/` : '/programas/graficos/';
        const metodo = this.state.graficoSelecionado.id ? 'put' : 'post';

        formData.append('titulo_grafico', this.state.graficoSelecionado.titulo_grafico);
        formData.append('categoria', this.state.graficoSelecionado.categoria);
        formData.append('programa_id', this.state.programa_id); 
        
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.graficoSelecionado.id) ? 'Gráfico atualizado com sucesso' : 'Gráfico cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

            this.carregarGraficos();
            this.handleCloseModalGraficos();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o gráfico, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'descricao') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerGrafico = (grafico) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover gráfico?',
            text: "Tem certeza que deseja remover o gráfico " + grafico.titulo_grafico + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (grafico.id) {
                    api({
                        method: 'delete',
                        url: `/programas/graficos/${grafico.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Gráfico removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarGraficos();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o gráfico, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        graficos: prevState.graficos.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O gráfico foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleShowModalGraficos = (grafico = []) => {
        this.setState({ showModalGraficos: true, graficoSelecionado: grafico });
    }

    handleCloseModalGraficos = () => {
        this.setState({ showModalGraficos: false, graficoSelecionado: []});
    }

    onClickPaginaGraficos = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarGraficos(num_page)
        });
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Gráficos do Programa</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalGraficos()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Gráfico'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.graficos && this.state.graficos.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Título</th>
                                            <th>Categoria</th>
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.graficos.results.map((grafico, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{grafico.id}</td>
                                                <td className="td-border">{grafico.titulo_grafico}</td>
                                                <td className="td-border">{categoriasDeGraficos[grafico.categoria]}</td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalGraficos(grafico)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerGrafico(grafico)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.graficos && this.state.graficos.results.length > 0 && (
                                        <Paginacao dados={this.state.graficos} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaGraficos} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhum gráfico cadastrado até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalGraficos} onHide={this.handleCloseModalGraficos} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.graficoSelecionado.id ? 'Editar Gráfico #' + this.state.graficoSelecionado.id : 'Adicionar Gráfico'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h4>Gráficos</h4>
                            <div className="row-list">
                                <Row>
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título do gráfico</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="titulo_grafico"
                                                value={this.state.graficoSelecionado.titulo_grafico} 
                                                onChange={e => this.handleGraficosChange(e, 'titulo_grafico')}
                                            />
                                        </Form.Group>
                                    </Col>                                                                                                        
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Categoria</Form.Label>
                                            <Form.Control as="select" name="categoria" value={this.state.graficoSelecionado.categoria} onChange={e => this.handleGraficosChange(e, 'categoria')}>
                                                <option value="">Categoria</option>
                                                {Object.entries(categoriasDeGraficos).map(([sigla, nome]) => (
                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>                                                    
                                </Row>
                            </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalGraficos}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={this.handleSalvarGrafico}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default GraficosPrograma;

